var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulletins(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    className: "svg-inline--fa",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.129 30.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_136",
    "data-name": "Trac\\xE9 136",
    d: "M28.444,3.561a1.063,1.063,0,0,1,0,1.5L26.227,7.28l-4.25-4.25L24.193.811a1.063,1.063,0,0,1,1.5,0l2.748,2.748ZM24.724,8.78l-4.25-4.25L6,19.011a1.063,1.063,0,0,0-.257.417l-1.711,5.13a.531.531,0,0,0,.672.672l5.13-1.711a1.063,1.063,0,0,0,.417-.255L24.724,8.782Z",
    transform: "translate(2.376 -0.5)",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_137",
    "data-name": "Trac\\xE9 137",
    d: "M1,27.565a3.188,3.188,0,0,0,3.188,3.188H27.565a3.188,3.188,0,0,0,3.188-3.188V14.814a1.063,1.063,0,1,0-2.125,0V27.565a1.063,1.063,0,0,1-1.063,1.063H4.188a1.063,1.063,0,0,1-1.063-1.063V4.188A1.063,1.063,0,0,1,4.188,3.125H18A1.063,1.063,0,0,0,18,1H4.188A3.188,3.188,0,0,0,1,4.188Z",
    transform: "translate(-1 0.063)",
    fill: "current",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletins);
export default __webpack_public_path__ + "static/media/bulletins.8dc5c332b6841cc7f947ef926ed04b6d.svg";
export { ForwardRef as ReactComponent };